module.exports = ".clickable {\r\n    cursor: pointer\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/audiences/audiences.component.css
// module id = ./src/app/audiences/audiences.component.css
// module chunks = main